import React, { useEffect } from 'react';
import { Select, MenuItem, SelectChangeEvent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { setLanguage, selectLanguage } from 'src/store/slices/language-slice';
import { ReactComponent as Chevron } from 'src/assets/svg/language-chevron.svg';
import { LanguagesCode } from 'src/i18n/constants';
import { getStorage, setLanguageStorage } from 'src/utils/local-storage-versioning';

import { styles } from './styles';
import { flagOptions } from './constants';

export const LanguageSelect = () => {
    const dispatch = useDispatch();
    const selectedLanguage = useSelector(selectLanguage);

    const {
        i18n: { changeLanguage },
    } = useTranslation();

    useEffect(() => {
        const storage = getStorage();
        if (storage.language && storage.language !== selectedLanguage) {
            changeLanguage(storage.language);
            dispatch(setLanguage(storage.language));
        }
    }, [changeLanguage, dispatch, selectedLanguage]);

    const handleChange = (event: SelectChangeEvent<string>) => {
        const newLanguage = event.target.value as LanguagesCode;
        changeLanguage(newLanguage);
        dispatch(setLanguage(newLanguage));
        setLanguageStorage(newLanguage);
    };

    const chevron = () => (
        <Chevron className="MuiSelect-custom-arrow-component" css={styles.chevron} />
    );

    return (
        <Select
            value={selectedLanguage} // Use language from Redux store
            onChange={handleChange}
            variant="standard"
            disableUnderline
            IconComponent={chevron}
            MenuProps={{
                sx: styles.menuList,
            }}
            css={styles.container}
        >
            {flagOptions.map(({ code, label, iconSrc }) => (
                <MenuItem key={code} value={code} css={styles.menuItem}>
                    <img src={iconSrc} alt="flag-icon" css={styles.icon} />
                    <Typography variant="subtitle2" className="language-select__country-name">
                        {label}
                    </Typography>
                </MenuItem>
            ))}
        </Select>
    );
};
